export class Cam {
  ip: string;
  port?: number;
 	name: string;
  isFound?: boolean;

  orientation?: string;
  quality?: number;
  colorEffect?: string;
  width?: string;

  constructor(ip: string, name: string)
  {
    this.ip = ip;
    this.name = name;
    this.port = 8080;
    this.isFound = false;

    this.orientation = 'portrait';
    this.quality = 50;
    this.colorEffect = 'none';
    this.width = '300px';
  }
}


// WEBPACK FOOTER //
// /home/rene/Documents/webcamgame/src/app/cam.ts